var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBannerSetIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "3E8D0D6F-C93A-43B8-8BBA-7E4007C6D5F8") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter-1"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceGraphic",
    type: "matrix",
    values: "0 0 0 0 0.560784 0 0 0 0 0.607843 0 0 0 0 0.662745 0 0 0 1.000000 0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "TurnItBlue---Milestone-2",
    stroke: "none",
    strokeWidth: 1,
    fill: "currentColor",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "15.0_Template_10",
    transform: "translate(-919.000000, -430.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(633.000000, 390.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "upload-(4)",
    transform: "translate(217.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(69.000000, 40.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.2795312,9.75046875 L40,9.75046875 L30.1084375,0 L30.1084375,8.57859375 C30.1084375,9.22476562 30.63375,9.75046875 31.2795313,9.75046875 L31.2795312,9.75046875 Z",
    id: "Path",
    fill: "currentColor",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.7646875,8.57859375 L27.7646875,0 L5.84617187,0 C5.19898437,0 4.67429687,0.5246875 4.67429687,1.171875 L4.67429687,9.06304688 L17.7642969,9.06304688 C21.3128125,9.06304688 24.1996875,11.9499219 24.1996875,15.4984375 L24.1996875,29.0992188 C24.1996875,32.6476563 21.3128125,35.5346094 17.7642969,35.5346094 L4.67429687,35.5346094 L4.67429687,38.828125 C4.67429687,39.4753125 5.1990625,40 5.84625,40 L38.828125,40 C39.4753125,40 40,39.4753125 40,38.828125 L40,12.0942187 L31.2795312,12.0942187 C29.3414062,12.0942187 27.7646875,10.5171094 27.7646875,8.57859375 Z",
    id: "Path",
    fill: "currentColor",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.9341406,29.0992187 L21.9341406,15.4984375 C21.9341406,13.1955469 20.0672656,11.3286719 17.764375,11.3286719 L4.16976563,11.3286719 C1.866875,11.3286719 2.22044605e-15,13.1955469 2.22044605e-15,15.4984375 L2.22044605e-15,29.0992187 C2.22044605e-15,31.4021094 1.866875,33.2689844 4.16976563,33.2689844 L17.764375,33.2689844 C20.0672656,33.2689844 21.9341406,31.4021094 21.9341406,29.0992187 Z M15.4076562,21.0911719 C14.9500781,21.5488281 14.2080469,21.5488281 13.7503906,21.0911719 L12.1389062,19.4796875 L12.1389062,27.9903906 C12.0769531,29.5452344 9.85648437,29.5440625 9.79515625,27.9903906 L9.79515625,19.4797656 L8.18375,21.0911719 C7.72617188,21.5488281 6.98414063,21.5488281 6.52648438,21.0911719 C6.06882813,20.6335156 6.06882813,19.8915625 6.52648438,19.4339062 L10.1383594,15.8219531 C10.5746875,15.3679687 11.3592969,15.3680469 11.795625,15.8219531 L15.4075781,19.4339062 C15.8653125,19.8915625 15.8653125,20.6335156 15.4076562,21.0911719 Z",
    id: "Shape",
    fill: "currentColor",
    fillRule: "nonzero"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBannerSetIcon);
export default __webpack_public_path__ + "static/media/BannerSetIcon.a1fa5e9b31222f414fca9a4795091e9a.svg";
export { ForwardRef as ReactComponent };